import styled from "styled-components"

const TableHeader = styled.div`
  display: flex;
`

export default TableHeader
